import './AboutSection.css';
import underlineImg from '../assets/underline.png';
import {
  IconLightning, IconMiniChart,
  IconRocket, IconCode, IconTarget, IconHeadset,
} from './Icons';

export default function AboutSection() {
  return (
    <section className="about-section">
      <div className="about-container">
        {/* Left */}
        <div className="about-left">
          <div className="badge about-badge">
            <span className="badge-icon"><IconLightning /></span>
            ABOUT MAD MARKETING CLUB
          </div>

          <h2 className="about-heading">
            We build. We scale.
            <span className="about-heading-gradient">We accelerate growth.</span>
          </h2>
          <img src={underlineImg} alt="" className="about-underline" />

          <p className="about-desc">
            Mad Marketing Club is a Pune-based e-commerce &amp; web development company founded
            in 2024 with a mission to help modern brands scale faster online. We specialize in
            high-converting Shopify stores, custom web experiences, performance marketing, and
            growth-focused digital solutions built for ambitious businesses.
          </p>
          <p className="about-desc">
            From strategy and branding to development and optimization — we help startups and
            growing brands launch, scale, and dominate in competitive markets. Our approach
            combines clean design, conversion psychology, and data-driven execution to create
            digital experiences that not only look premium but also generate measurable business growth.
          </p>
        </div>

        {/* Right — Instagram tablet mockup */}
        <div className="about-right">
          <div className="about-tablet-outer">
            <div className="about-tablet">
              <div className="about-tablet-camera" />
              <div className="about-tablet-screen">
                <iframe
                  src="https://www.instagram.com/madandaaz/embed/"
                  className="about-tablet-iframe"
                  frameBorder="0"
                  scrolling="no"
                  allowTransparency
                  allowFullScreen
                  title="Mad Andaaz Instagram Feed"
                />
              </div>
              <div className="about-tablet-home-bar" />
            </div>
            <div className="about-exp-badge">
              <div className="about-exp-icon"><IconMiniChart /></div>
              <div className="about-exp-text">
                <span className="about-exp-num">10+</span>
                <span className="about-exp-label">Years<br />Of Combined<br />Experience</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Features row */}
      <div className="about-features">
        <div className="about-feature">
          <div className="about-feature-icon"><IconRocket /></div>
          <div className="about-feature-title">Growth Focused</div>
          <div className="about-feature-desc">We build strategies that drive real, measurable growth.</div>
        </div>
        <div className="about-feature">
          <div className="about-feature-icon"><IconCode /></div>
          <div className="about-feature-title">Tech-Driven</div>
          <div className="about-feature-desc">Modern, scalable &amp; high-performing e-commerce solutions.</div>
        </div>
        <div className="about-feature">
          <div className="about-feature-icon"><IconTarget /></div>
          <div className="about-feature-title">Data-Backed</div>
          <div className="about-feature-desc">Every decision is driven by data, tested for results.</div>
        </div>
        <div className="about-feature">
          <div className="about-feature-icon"><IconHeadset /></div>
          <div className="about-feature-title">End-to-End Partner</div>
          <div className="about-feature-desc">We partner with you at every step of your e-commerce journey.</div>
        </div>
      </div>
    </section>
  );
}
